import {auth} from "../../firebase";

export async function getSuperUid(): Promise<string | null | undefined | object> {
  const tokenResult = await auth.currentUser?.getIdTokenResult();
  return tokenResult?.claims.superUid;
}
